/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { FeedResource, GcsStorageFeedResource } from "@octopusdeploy/octopus-server-client";
import { FeedType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import AdvancedFeedCredentialsFormSection, { AuthenticationType } from "../AdvancedFeedCredentialsFormSection";
import RetryAttemptsFormSection from "../RetryAttemptsFormSection";
import type { FeedEditProps } from "./feedTypeRegistry";
import feedTypeRegistry from "./feedTypeRegistry";
const googleAuthUsername: string = "_json_key";
const GcsStorageFeed: React.FC<FeedEditProps<GcsStorageFeedResource>> = (props) => {
    return (<React.Fragment>
            <RetryAttemptsFormSection backoffSeconds={props.feed.DownloadRetryBackoffSeconds} onBackoffSecondsChanged={(seconds) => props.onChange({ ...props.feed, DownloadRetryBackoffSeconds: seconds })} attemptCount={props.feed.DownloadAttempts} onAttemptCountChanged={(count) => props.onChange({ ...props.feed, DownloadAttempts: count })} containerKey={props.expandableContainerKey}/>
            <AdvancedFeedCredentialsFormSection model={{
            username: googleAuthUsername,
            password: props.feed.ServiceAccountJsonKey,
        }} isNew={!props.feed.Id} authenticationType={props.feed.ServiceAccountJsonKey?.HasValue ? AuthenticationType.GoogleCloudJsonKey : props.feed.OidcAuthentication ? AuthenticationType.Oidc : AuthenticationType.GoogleCloudJsonKey} oidcModel={props.feed.OidcAuthentication} onChanged={(model, oidcModel) => props.onChange({
            ...props.feed,
            UseServiceAccountKey: model.password?.HasValue ?? false,
            ServiceAccountJsonKey: model.password ?? { HasValue: false },
            OidcAuthentication: oidcModel,
        })} supportedAuthenticationTypes={[AuthenticationType.GoogleCloudJsonKey, AuthenticationType.Oidc]} containerKey={props.expandableContainerKey}/>
        </React.Fragment>);
};
GcsStorageFeed.displayName = "GcsStorageFeed"
feedTypeRegistry.registerFeedType({
    type: FeedType.GcsStorage,
    text: "Google Cloud Storage",
    edit: GcsStorageFeed as React.ComponentType<FeedEditProps<FeedResource>>,
    hasUri: false,
});
export default GcsStorageFeed;
